import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import withLocalization from "../../../hoc/withLocalization";
import Select from "../../../elements/Select";

const AbsenceStatusesSelectWidgetMobx = inject('commonStore', 'userStore')(withLocalization(observer(class AbsenceStatusesSelectWidgetMobx extends Component {
    constructor(props) {
        super(props);
        this.state = { userAbsentTypes: null };
    }

    componentDidMount() {
        this.fetchForUser();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.options?.user_id !== this.props.options?.user_id) {
            this.fetchForUser();
        }
    }

    fetchForUser = async () => {
        const userId = this.props.options?.user_id;
        if (!userId) {
            this.lastFetchedUserId = null;
            this.setState({ userAbsentTypes: null });
            return;
        }
        // componentDidMount and componentDidUpdate can both fire for the same user_id transition
        // (e.g. once the uiSchema stamp lands right after mount) - dedupe so we only ever hit the API once per user.
        if (userId === this.lastFetchedUserId) return;
        this.lastFetchedUserId = userId;
        try {
            const res = await this.props.userStore.getAvailableAbsenceTypesForUser(userId);
            this.setState({ userAbsentTypes: res.absentTypes || [] });
        } catch (err) {
            console.error(err);
            this.lastFetchedUserId = null;
            this.setState({ userAbsentTypes: [] });
        }
    };

    render() {
        const { value, disabled, t } = this.props;
        const { client } = this.props.commonStore?.config || {};
        const { userAbsentTypes } = this.state;
        // when options.user_id is set (admin filing on behalf of a different employee), use that employee's
        // specific list instead of the logged-in user's own personalized list from commonStore.config
        const statuses = userAbsentTypes !== null ? userAbsentTypes : (client?.data?.extendedRules?.absent_types || []);

        const options = statuses.map(({ code, name }) => ({
            label: t(name),
            value: code
        }));

        const currentSelect = options.find(opt => String(opt.value) === String(value)) || null;

        return (
            <Select
                options={options}
                value={currentSelect}
                isDisabled={disabled}
                onChange={selected => this.props.onChange(selected ? selected.value : null)}
                isClearable={false}
            />
        );
    }
})));

export const AbsenceStatusesSelectWidget = observer(class AbsenceStatusesSelectWidget extends Component {
    render() {
        return <AbsenceStatusesSelectWidgetMobx {...this.props} />;
    }
});

export const AbsenceStatusesSelectWidgetOnEdit = observer(class AbsenceStatusesSelectWidgetOnEdit extends Component {
    render() {
        return <AbsenceStatusesSelectWidgetMobx {...this.props} disabled />;
    }
});
